// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'accueil',
    path: '/dashboard/home',
    icon: icon('ic_home'),
  },
  {
    title: 'compétiteurs',
    path: '/dashboard/user',
    icon: icon('ic_user'),
  },
  {
    title: 'nominations',
    path: '/dashboard/nomination',
    icon: icon('ic_nomination'),
  },
  {
    title: 'votes',
    path: '/dashboard/vote/form',
    icon: icon('ic_analytics'),
  },
  {
    title: 'archives',
    path: '/dashboard/archives',
    icon: icon('ic_archive'),
  },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
